/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Feedbackquizcompletedat2Inputs */

const de__field_feedbackquizcompletedat2 = /** @type {(inputs: _Field_Feedbackquizcompletedat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback-Quiz absolviert am`)
};

/**

* @param {_Field_Feedbackquizcompletedat2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_feedbackquizcompletedat2 = /** @type {((inputs?: _Field_Feedbackquizcompletedat2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Feedbackquizcompletedat2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_feedbackquizcompletedat2(inputs)
});
export { _field_feedbackquizcompletedat2 as "_field_feedbackquizCompletedAt" }